import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const useNotUsedLabelStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: pxToRem(20),
    },
    grayText: {
        color: theme.palette.grey[500],
        fontSize: pxToRem(14),
        textAlign: 'center',
    },
}))

export const NotUsedLabel = React.memo(() => {
    const classes = useNotUsedLabelStyles()

    return (
        <div className={classes.container}>
            <Typography
                data-testid="notUsedLabel"
                component="span"
                className={classes.grayText}
            >
                Not Used
            </Typography>
        </div>
    )
})
